import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { distinctUntilChanged, first, flatMap, mergeMap, Observable, take, takeWhile } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCountsSortTypeState } from '@app/modules/counts/store/selectors/counts.selectors';

@Injectable()
export class InventorySortTypeInterceptor implements HttpInterceptor {
  private sortType;
  constructor(private store$: Store) {

    this.store$.select(selectCountsSortTypeState).pipe(

    ).subscribe((_sortType) => {
      this.sortType = _sortType.active;
    })
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request);
  }
}
